var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", { attrs: { title: "Recommendations" } }, [
    _c("div", { staticClass: "text-gray-600 text-sm mb-4" }, [
      _vm._v("Best practices and tips for your system")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "space-y-3" }, [
      _c("div", { staticClass: "flex items-start gap-3" }, [
        _c(
          "span",
          {
            staticClass:
              "bg-green-500 text-white rounded-full px-3 py-1 text-xs font-semibold"
          },
          [_vm._v("Security")]
        ),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "font-semibold text-gray-900" }, [
            _vm._v("Enable Multi-Factor Authentication")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-gray-500 text-xs" }, [
            _vm._v(
              "Increase account security by requiring a second verification step."
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex items-start gap-3" }, [
        _c(
          "span",
          {
            staticClass:
              "bg-gray-200 text-gray-700 rounded-full px-3 py-1 text-xs font-semibold"
          },
          [_vm._v("Backup")]
        ),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "font-semibold text-gray-900" }, [
            _vm._v("Schedule Regular Backups")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-gray-500 text-xs" }, [
            _vm._v("Keep your data safe by automating daily backups.")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex items-start gap-3" }, [
        _c(
          "span",
          {
            staticClass:
              "bg-yellow-400 text-white rounded-full px-3 py-1 text-xs font-semibold"
          },
          [_vm._v("Monitoring")]
        ),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "font-semibold text-gray-900" }, [
            _vm._v("Review Access Logs")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-gray-500 text-xs" }, [
            _vm._v(
              "Identify potential suspicious activities by monitoring logs."
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10fe568c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10fe568c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cards/StatCards/ReccomendationsRow/ReccomendationCard.vue
// module id = null
// module chunks = 